import {
  ApolloClient,
  InMemoryCache,
  from,
  createHttpLink,
} from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { logException } from './logging/sentry'

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_CMS_BASE_URL}/api/graphql`,
})

const errorHandler = onError(({ networkError }) => {
  if (networkError) {
    // Log an expected exception message for oncall to alert on
    logException(new Error('CMS Graphql returned a non 200 response'))

    // Log the actual error for debugging
    logException(networkError)
  }
})

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([errorHandler, httpLink]),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
})
